import * as actions from "appRedux/actions/chargeSchedule/ChargeReservationActionType"
import { ChargeScheduleProcess, chargeScheduleType, RateBreakdownGroup } from "./chargeType"

type chargeReservationDetailDataSource = {
    booking_name?: string | null
    status?: string | null
    details: any[]
    book_type?: string | null
}

export interface chargeReservationState {
    loader: boolean,
    keyword: string,
    dataSource: chargeScheduleType[],
    breakdownDataSource: RateBreakdownGroup[],
    breakdownLoader: boolean,
    detailDataSource: chargeReservationDetailDataSource,
    filterChargeSchedule: any,
    process: ChargeScheduleProcess
}

const initialState: chargeReservationState = {
    loader: false,
    keyword: '',
    dataSource: [],
    breakdownDataSource: [],
    breakdownLoader: false,
    detailDataSource: {
        booking_name: null,
        status: null,
        details: [],
        book_type: null
    },
    filterChargeSchedule: [],
    process: { status: false, action: "", message: "" }
}

export default (state: chargeReservationState = initialState, action: actions.ChargeAction): chargeReservationState => {
    switch (action.type) {
        case actions.CHARGE_RESERVATION_REQUEST: {
            return {
                ...state,
                loader: true,
                dataSource: [],
                process: { status: false, action: "", message: "" }
            }
        }
        case actions.CHARGE_RESERVATION_DETAIL_REQUEST: {
            return {
                ...state,
                detailDataSource: {
                    booking_name: null,
                    status: null,
                    details: [],
                    book_type: null
                },
                process: { status: false, action: "", message: "" }
            }
        }
        case actions.CHARGE_RESERVATION_UPDATE: {
            return {
                ...state,
                process: { status: false, action: "", message: "" }
            }
        }
        case actions.CHARGE_RESERVATION_PROCESS_SUCCESS: {
            return {
                ...state,
                process: action.payload
            }
        }
        case actions.CHARGE_RESERVATION_DATASOURCE_SUCCESS: {
            return {
                ...state,
                loader: false,
                dataSource: action.payload
            }
        }
        case actions.CHARGE_RESERVATION_BREAKDOWN_REQUEST: {
            return {
                ...state,
                breakdownLoader: true,
                breakdownDataSource: [],
                process: { status: false, action: "", message: "" }
            }
        }
        case actions.CHARGE_RESERVATION_BREAKDOWN_SUCCESS: {
            return {
                ...state,
                breakdownLoader: false,
                breakdownDataSource: action.payload
            }
        }
        case actions.CHARGE_RESERVATION_DETAIL_DATASOURCE_SUCCESS: {
            return {
                ...state,
                detailDataSource: action.payload
            }
        }
        case actions.CHARGE_RESERVATION_SET_FILTER: {
            return {
                ...state,
                filterChargeSchedule: action.payload
            }
        }
        case actions.CHARGE_RESERVATION_PROCESS_RESET: {
            return {
                ...state,
                process: { status: false, action: "", message: "" }
            }
        }
        default:
            return state;
    }
}
